import React, { useEffect, useState, useContext } from 'react'

import { firestore } from '../../../firebase';

import { totalEquityCalculator } from '../../../helpers/financeCalculator';
import StateContext from '../../../StateContext';

function TotalEquity() {

    const appState = useContext(StateContext)
    const [equity, setEquity] = useState([]);

    useEffect(() => {

        try {
            const equityRef = firestore.collection("users").doc(appState.userId).collection("egenkapital");
            equityRef.onSnapshot(({docs}) => {
                const equity = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setEquity(equity);
            })
        } catch (error) {
            
        }

    }, [appState.userId])

    return (
        <React.Fragment>
            {totalEquityCalculator(equity)}
        </React.Fragment>
    )
}
export default TotalEquity